import { useSearchContext } from '../../context/Search';
import useMyLocation from '../../common/hooks/useMyLocation';

const useMylocationButtonLogic = () => {
  const { useMyLocationButtonRef } = useSearchContext();
  const { fetchMyLocation, loading } = useMyLocation();

  return { handleClick: fetchMyLocation, loading, ref: useMyLocationButtonRef };
};

export default useMylocationButtonLogic;
